export var EAlkButtonShape;
(function (EAlkButtonShape) {
    EAlkButtonShape["ROUND"] = "round";
    EAlkButtonShape["SQUARE"] = "square";
    EAlkButtonShape["FLAT"] = "flat";
})(EAlkButtonShape || (EAlkButtonShape = {}));
